export default __webpack_public_path__ + "static/media/jio.17c2dfd2.svg";